// import { useEffect, useState } from "react"
// import { IndigoButton, GrayButton, PinkButton, TealButton, SlateLightButton } from "../../Atoms/Buttons/ColorButtons"
// const ModalSwitchFooter = ({
//      modal1switch, modal1caption, modal1isOpen,
//      modal2switch, modal2caption, modal2isOpen,
//      modal2, 
//      modal3, 

//      missingRequiredFields,
//      saveOnClickMethod1, 
//      closeOnClickMethod, 
//      submitButtonCaption1, 
//      submitButtonCaption2, 
//      saveOnClickMethod2, 
//      cancelButtonCaption, 
//      loading, 
//      lang})=> {

//   const [missingFields, setMissingFields] = useState(missingRequiredFields)

//   useEffect(() => {
//     setMissingFields(missingRequiredFields)
//   }, [missingRequiredFields])
  

//      return (       

//      <div className="flex justify-center items-center bottom-32 w-full opacity-95">
//      <div className={`flex flex-col bg-white dark:bg-slate-500 rounded-lg items-center justify-center gap-1 bottom-16 z-50 p-3`}>
// {/* <div>
//             <SlateLightButton 
//               onClick={closeOnClickMethod} 
//               caption={modal1caption || "Cancel"}
//             />
// </div> */}

// {modal1caption &&<div> <SlateLightButton 
//               isActive={modal1isOpen}
//               loading={loading}
//               onClick={modal1switch}
//               // onMouseDown={()=>{saveOnClickMethod2();}}
//               // onClick={()=>{missingRequiredFields === false && closeOnClickMethod()}}
//               // onClick
//               caption={modal1caption || "modal1caption"}
//             /></div>}


// {modal2caption &&<div> <SlateLightButton 
//               isActive={modal2isOpen}
//               border={true}
//               loading={loading}
//               onClick={modal2switch}
//               // onMouseDown={()=>{saveOnClickMethod2();}}
//               // onClick={()=>{missingRequiredFields === false && closeOnClickMethod()}}
//               // onClick
//               caption={modal2caption || "modal1caption"}
//             /></div>}

// {/* <div>
//             <TealButton 
//               loading={loading}
//               onMouseDown={()=>{saveOnClickMethod1();}}
//               onClick={()=>{Object.values(missingFields).includes(true) === false && closeOnClickMethod()}}
//               caption={submitButtonCaption1 || "Save Changes"}
//             />
//             </div>  */}
//    </div></div>)
// }

// export default ModalSwitchFooter
























import { useEffect, useState } from "react"
import { IndigoButton, GrayButton, PinkButton, TealButton, SlateLightButton } from "../../Atoms/Buttons/ColorButtons"
const ModalSwitchFooter = ({
     modal1switch, modal1caption, modal1isOpen,
     modal2switch, modal2caption, modal2isOpen,
     modal2, 
     modal3, 

     missingRequiredFields,
     saveOnClickMethod1, 
     closeOnClickMethod, 
     submitButtonCaption1, 
     submitButtonCaption2, 
     saveOnClickMethod2, 
     cancelButtonCaption, 
     loading, 
     lang})=> {

  const [missingFields, setMissingFields] = useState(missingRequiredFields)

  useEffect(() => {
    setMissingFields(missingRequiredFields)
  }, [missingRequiredFields])
  

     return (       

     <div className="invisible lg:visible absolute flex justify-center items-center bottom-2 w-full opacity-100">
     <div className={`flex bg-slate-100 dark:bg-slate-500 rounded-lg items-center justify-center space-x-2 bottom-16 z-10 p-3`}>
{/* <div>
            <SlateLightButton 
              onClick={closeOnClickMethod} 
              caption={modal1caption || "Cancel"}
            />
</div> */}

{modal1caption &&<div> <SlateLightButton 
              isActive={modal1isOpen}
              loading={loading}
              onClick={modal1switch}
              // onMouseDown={()=>{saveOnClickMethod2();}}
              // onClick={()=>{missingRequiredFields === false && closeOnClickMethod()}}
              // onClick
              caption={modal1caption || "modal1caption"}
            /></div>}


{modal2caption &&<div> <SlateLightButton 
              isActive={modal2isOpen}
              border={true}
              loading={loading}
              onClick={modal2switch}
              // onMouseDown={()=>{saveOnClickMethod2();}}
              // onClick={()=>{missingRequiredFields === false && closeOnClickMethod()}}
              // onClick
              caption={modal2caption || "modal1caption"}
            /></div>}

{/* <div>
            <TealButton 
              loading={loading}
              onMouseDown={()=>{saveOnClickMethod1();}}
              onClick={()=>{Object.values(missingFields).includes(true) === false && closeOnClickMethod()}}
              caption={submitButtonCaption1 || "Save Changes"}
            />
            </div>  */}
   </div></div>)
}

export default ModalSwitchFooter